
define('text!templates/modules/questionnaire/responses/response-content.html',[],function () { return '<div class="panel-body">\n    <ul class="menu-actions nav nav-pills"></ul>\n\n    <div class="results-header">\n        <h4>{{title}}</h4>\n        <p>{{guidelines}}</p>\n    </div>\n    <div id="results-list"></div>\n</div>\n';});

